// The code mailed to prove an account's email, and what the API says about it.
// POST /Account/resendConfirmEmail and /Account/confirmEmail refuse with a
// sentence and no code, so their refusals are told by their words.

/** How long a mailed code is accepted: the backend's 300 seconds. */
export const CODE_LIFETIME_MS = 5 * 60 * 1000;

// The sentences a refusal carries, in whichever shape it arrived: an HTTP error
// has the envelope on its response, a refusal on a 200 is the envelope itself.
const refusalSentences = (error) => {
   const envelope = error?.response ? error.response.data : error?.isAxiosError ? null : error;
   return [...(Array.isArray(envelope?.errors) ? envelope.errors : []), envelope?.message].filter(
      (sentence) => typeof sentence === "string"
   );
};

/**
 * resendConfirmEmail kept the code it sent earlier, which is still valid, and
 * sent no new one. A code that has run out is replaced instead.
 */
export const isCodeStillPending = (error) =>
   refusalSentences(error).some((sentence) =>
      sentence.includes("already has a pending confirmation code")
   );

/** confirmEmail: the code's five minutes are over. The server lets go of it. */
export const isCodeExpired = (error) =>
   refusalSentences(error).some((sentence) => sentence.startsWith("Code is expired"));

/** What is left of a code's five minutes at `now`, never below zero. */
export const codeTimeLeft = (sentAt, now) =>
   sentAt == null ? 0 : Math.min(CODE_LIFETIME_MS, Math.max(0, sentAt + CODE_LIFETIME_MS - now));

/** 4:05 for 245 seconds. Rounded up, so it reads 0:00 only once the time is up. */
export const formatCodeTimeLeft = (ms) => {
   const seconds = Math.ceil(ms / 1000);
   return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
};
